import { Link } from 'react-router-dom';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Pagination, Box, IconButton, Typography
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import LinkIcon from '@mui/icons-material/Link';
import CopyableText from '../SharedArea/CopyableText';

const AccessSerialTable = ({ serials, total, page, limit, setPage, onEdit, onDelete, onLink}) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <TableContainer
                component={Paper}
                sx={{
                    minWidth: 1000,
                    overflow: 'auto',
                    flex: 1,
                    borderRadius: 0,
                    boxShadow: 'none'
                }}
            >
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>איש קשר</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>אימייל</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>קוד סיריאל</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>תאריך התחלה</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>תאריך סיום</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>מקסימום משתמשים</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>משתמשים שמימשו</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>פרופיל הרשאות</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>תאריך יצירה</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>פעולות</TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {serials.map((serial) => (
                            <TableRow key={serial._id}>
                                <TableCell>{serial.name}</TableCell>

                                <TableCell>
                                    {serial.email && <CopyableText text={serial.email} iconPosition="left" />}
                                </TableCell>

                                <TableCell>
                                    {serial.serial && <CopyableText text={serial.serial} iconPosition="left" />}
                                </TableCell>

                                <TableCell>
                                    {serial.date?.start ? new Date(serial.date.start).toLocaleDateString() : ''}
                                </TableCell>

                                <TableCell>
                                    {serial.date?.end ? new Date(serial.date.end).toLocaleDateString() : ''}
                                </TableCell>

                                <TableCell>{serial.maxUsers}</TableCell>

                                <TableCell>
                                    <Typography
                                        variant="body2"
                                        color="primary"
                                        component={Link}
                                        to={`/customers?serial=${serial.serial}`}
                                    >
                                        {serial.usedUsers}
                                    </Typography>
                                </TableCell>

                                {/* הצגת שם פרופיל ההרשאות של הסיריאל */}
                                <TableCell>
                                    {serial.permissionProfile?.name ? (
                                        <Typography
                                            variant="body2"
                                            color="primary"
                                            component={Link}
                                            to={`/profiles?name=${serial.permissionProfile.name}`}
                                        >
                                            {serial.permissionProfile.name}
                                        </Typography>
                                    ) : (
                                        ''
                                    )}
                                </TableCell>

                                <TableCell sx={{ direction: 'rtl' }}>
                                    {new Date(serial.createdAt).toLocaleString('he-IL', {
                                        timeZone: 'Asia/Jerusalem',
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                    })}
                                </TableCell>

                                <TableCell sx={{ minWidth: 120 }}>
                                    <IconButton onClick={() => onEdit(serial)}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton
                                        onClick={() => onDelete(serial)}
                                        sx={{ color: 'red' }}
                                        disabled={serial.usedUsers > 0}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                    <IconButton onClick={() => onLink(serial)}>
                                        <LinkIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box mt={0} py={1} display="flex" justifyContent="center">
                <Pagination
                    count={Math.ceil(total / limit)}
                    page={page}
                    onChange={(e, val) => setPage(val)}
                    color="primary"
                />
            </Box>
        </Box>
    );
};

export default AccessSerialTable;
